module.exports = __webpack_public_path__ + "img/Group-11600.f086936c.svg";